// https://unpkg.com/@swup/a11y-plugin@5.0.0/dist/index.umd.js

!(function (t, e) {
  "object" == typeof exports && "undefined" != typeof module
    ? (module.exports = e())
    : "function" == typeof define && define.amd
    ? define(e)
    : ((t || self).SwupA11yPlugin = e());
})(this, function () {
  function t() {
    return (
      (t = Object.assign
        ? Object.assign.bind()
        : function (t) {
            for (var e = 1; e < arguments.length; e++) {
              var n = arguments[e];
              for (var o in n)
                Object.prototype.hasOwnProperty.call(n, o) && (t[o] = n[o]);
            }
            return t;
          }),
      t.apply(this, arguments)
    );
  }
  const e = (t) =>
    String(t)
      .split(".")
      .map((t) => String(parseInt(t || "0", 10)))
      .concat(["0", "0"])
      .slice(0, 3)
      .join(".");
  class n {
    constructor() {
      (this.isSwupPlugin = !0),
        (this.swup = void 0),
        (this.version = void 0),
        (this.requires = {}),
        (this.handlersToUnregister = []);
    }
    mount() {}
    unmount() {
      this.handlersToUnregister.forEach((t) => t()),
        (this.handlersToUnregister = []);
    }
    _beforeMount() {
      if (!this.name)
        throw new Error(
          "You must define a name of plugin when creating a class."
        );
    }
    _afterUnmount() {}
    _checkRequirements() {
      return (
        "object" != typeof this.requires ||
          Object.entries(this.requires).forEach(([t, n]) => {
            if (
              !(function (t, n, o) {
                const i = (function (t, e) {
                  var n;
                  if ("swup" === t) return null != (n = e.version) ? n : "";
                  {
                    var o;
                    const n = e.findPlugin(t);
                    return null != (o = null == n ? void 0 : n.version)
                      ? o
                      : "";
                  }
                })(t, o);
                return (
                  !!i &&
                  ((t, n) =>
                    n.every((n) => {
                      const [, o, i] = n.match(/^([\D]+)?(.*)$/) || [];
                      var r, s;
                      return ((t, e) => {
                        const n = {
                          "": (t) => 0 === t,
                          ">": (t) => t > 0,
                          ">=": (t) => t >= 0,
                          "<": (t) => t < 0,
                          "<=": (t) => t <= 0,
                        };
                        return (n[e] || n[""])(t);
                      })(
                        ((s = i),
                        (r = e((r = t))),
                        (s = e(s)),
                        r.localeCompare(s, void 0, { numeric: !0 })),
                        o || ">="
                      );
                    }))(i, n)
                );
              })(t, (n = Array.isArray(n) ? n : [n]), this.swup)
            ) {
              const e = `${t} ${n.join(", ")}`;
              throw new Error(
                `Plugin version mismatch: ${this.name} requires ${e}`
              );
            }
          }),
        !0
      );
    }
    on(t, e, n = {}) {
      var o;
      e =
        !(o = e).name.startsWith("bound ") || o.hasOwnProperty("prototype")
          ? e.bind(this)
          : e;
      const i = this.swup.hooks.on(t, e, n);
      return this.handlersToUnregister.push(i), i;
    }
    once(e, n, o = {}) {
      return this.on(e, n, t({}, o, { once: !0 }));
    }
    before(e, n, o = {}) {
      return this.on(e, n, t({}, o, { before: !0 }));
    }
    replace(e, n, o = {}) {
      return this.on(e, n, t({}, o, { replace: !0 }));
    }
    off(t, e) {
      return this.swup.hooks.off(t, e);
    }
  }
  !(function () {
    if (
      "undefined" != typeof window &&
      "undefined" != typeof document &&
      "undefined" != typeof HTMLElement
    ) {
      var t = !1;
      try {
        var e = document.createElement("div");
        e.addEventListener(
          "focus",
          function (t) {
            t.preventDefault(), t.stopPropagation();
          },
          !0
        ),
          e.focus(
            Object.defineProperty({}, "preventScroll", {
              get: function () {
                if (
                  navigator &&
                  void 0 !== navigator.userAgent &&
                  navigator.userAgent &&
                  navigator.userAgent.match(/Edge\/1[7-8]/)
                )
                  return (t = !1);
                t = !0;
              },
            })
          );
      } catch (t) {}
      if (void 0 === HTMLElement.prototype.nativeFocus && !t) {
        HTMLElement.prototype.nativeFocus = HTMLElement.prototype.focus;
        var n = function (t) {
          for (var e = 0; e < t.length; e++)
            (t[e][0].scrollTop = t[e][1]), (t[e][0].scrollLeft = t[e][2]);
          t = [];
        };
        HTMLElement.prototype.focus = function (t) {
          if (t && t.preventScroll) {
            var e = (function (t) {
              for (
                var e = t.parentNode,
                  n = [],
                  o = document.scrollingElement || document.documentElement;
                e && e !== o;

              )
                (e.offsetHeight < e.scrollHeight ||
                  e.offsetWidth < e.scrollWidth) &&
                  n.push([e, e.scrollTop, e.scrollLeft]),
                  (e = e.parentNode);
              return n.push([(e = o), e.scrollTop, e.scrollLeft]), n;
            })(this);
            if ("function" == typeof setTimeout) {
              var o = this;
              setTimeout(function () {
                o.nativeFocus(), n(e);
              }, 0);
            } else this.nativeFocus(), n(e);
          } else this.nativeFocus();
        };
      }
    }
  })();
  class o extends URL {
    constructor(t, e = document.baseURI) {
      super(t.toString(), e), Object.setPrototypeOf(this, o.prototype);
    }
    get url() {
      return this.pathname + this.search;
    }
    static fromElement(t) {
      const e = t.getAttribute("href") || t.getAttribute("xlink:href") || "";
      return new o(e);
    }
    static fromUrl(t) {
      return new o(t);
    }
  }
  function i(t, e) {
    return Object.keys(e).reduce(
      (t, n) => t.replace(`{${n}}`, e[n] || ""),
      t || ""
    );
  }
  class r {
    constructor() {
      (this.id = "swup-announcer"),
        (this.style =
          "position:absolute;top:0;left:0;clip:rect(0 0 0 0);clip-path:inset(50%);overflow:hidden;white-space:nowrap;word-wrap:normal;width:1px;height:1px;"),
        (this.region = void 0),
        (this.region = this.getRegion() ?? this.createRegion());
    }
    getRegion() {
      return document.getElementById(this.id);
    }
    createRegion() {
      const t = (function (t) {
        const e = document.createElement("template");
        return (e.innerHTML = t), e.content.children[0];
      })(
        `<p aria-live="assertive" aria-atomic="true" id="${this.id}" style="${this.style}"></p>`
      );
      return document.body.appendChild(t), t;
    }
    announce(t, e) {
      return (
        void 0 === e && (e = 0),
        new Promise((n) => {
          setTimeout(() => {
            this.region.textContent === t && (t = `${t}.`),
              (this.region.textContent = ""),
              (this.region.textContent = t),
              n();
          }, e);
        })
      );
    }
  }
  function s(t) {
    let e;
    if (
      ((e = "string" == typeof t ? document.querySelector(t) : t),
      !(e instanceof HTMLElement))
    )
      return;
    const n = e.getAttribute("tabindex");
    e.setAttribute("tabindex", "-1"),
      e.focus({ preventScroll: !0 }),
      null !== n && e.setAttribute("tabindex", n);
  }
  return class extends n {
    constructor(t) {
      void 0 === t && (t = {}),
        super(),
        (this.name = "SwupA11yPlugin"),
        (this.requires = { swup: ">=4" }),
        (this.defaults = {
          headingSelector: "h1",
          respectReducedMotion: !0,
          autofocus: !1,
          announcements: {
            visit: "Navigated to: {title}",
            url: "New page at {url}",
          },
        }),
        (this.options = void 0),
        (this.announcer = void 0),
        (this.announcementDelay = 100),
        (this.rootSelector = "body"),
        (this.handleAnchorScroll = (t, e) => {
          let { hash: n } = e;
          const o = this.swup.getAnchorElement(n);
          o instanceof HTMLElement && s(o);
        }),
        (this.options = { ...this.defaults, ...t }),
        (this.announcer = new r());
    }
    mount() {
      this.swup.hooks.create("content:announce"),
        this.swup.hooks.create("content:focus"),
        this.before("visit:start", this.prepareVisit),
        this.on("visit:start", this.markAsBusy),
        this.on("visit:end", this.unmarkAsBusy),
        this.on("visit:end", this.focusContent),
        this.on("visit:end", this.announceContent),
        this.on("scroll:anchor", this.handleAnchorScroll),
        this.before("visit:start", this.disableAnimations),
        this.before("link:self", this.disableAnimations),
        this.before("link:anchor", this.disableAnimations),
        (this.swup.announce = this.announce.bind(this));
    }
    unmount() {
      this.swup.announce = void 0;
    }
    announce(t) {
      try {
        return Promise.resolve(this.announcer.announce(t)).then(function () {});
      } catch (t) {
        return Promise.reject(t);
      }
    }
    markAsBusy() {
      document.documentElement.setAttribute("aria-busy", "true");
    }
    unmarkAsBusy() {
      document.documentElement.removeAttribute("aria-busy");
    }
    prepareVisit(t) {
      t.a11y = { announce: void 0, focus: this.rootSelector };
    }
    announceContent(t) {
      this.swup.hooks.callSync("content:announce", t, void 0, (t) => {
        void 0 === t.a11y.announce &&
          (t.a11y.announce = this.getPageAnnouncement()),
          t.a11y.announce &&
            this.announcer.announce(t.a11y.announce, this.announcementDelay);
      });
    }
    focusContent(t) {
      this.swup.hooks.callSync("content:focus", t, void 0, (t) => {
        t.a11y.focus &&
          ((this.options.autofocus &&
            !0 ===
              (function () {
                const t = (function () {
                  const t = document.querySelector("body [autofocus]");
                  if (
                    t &&
                    !t.closest('[inert], [aria-disabled], [aria-hidden="true"]')
                  )
                    return t;
                })();
                return !!t && (t !== document.activeElement && t.focus(), !0);
              })()) ||
            s(t.a11y.focus));
      });
    }
    getPageAnnouncement() {
      const { headingSelector: t, announcements: e } = this.options;
      return (function (t) {
        let { headingSelector: e = "h1", announcements: n = {} } = t;
        const r = document.documentElement.lang || "*",
          { href: s, url: u, pathname: c } = o.fromUrl(window.location.href),
          a = n[r] ?? n["*"] ?? n;
        if ("object" != typeof a) return;
        const h = document.querySelector(e);
        h ||
          console.warn(
            `SwupA11yPlugin: No main heading (${e}) found on new page`
          );
        const l =
          h?.getAttribute("aria-label") ||
          h?.textContent ||
          document.title ||
          i(a.url, { href: s, url: u, path: c });
        return i(a.visit, { title: l, href: s, url: u, path: c });
      })({ headingSelector: t, announcements: e });
    }
    disableAnimations(t) {
      this.options.respectReducedMotion &&
        window.matchMedia("(prefers-reduced-motion: reduce)").matches &&
        ((t.animation.animate = !1), (t.scroll.animate = !1));
    }
  };
});
//# sourceMappingURL=index.umd.js.map
